export enum LocalStorageTypes {
  BEARER = 'PLUM_BEARER',
  APPLICATION_ID = 'PLUM_APPLICATION_ID',
  BRAND = 'BRAND',
}
